export default (function (value) {
  return typeof Map !== 'undefined' && value instanceof Map;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isMap.js
// module id = 333
// module chunks = 2